import Minus3 from '@assets/icons/minus3.svg'
import { Icon } from './Icon'

export const Minus3Icon = Icon(Minus3)
